import { render, staticRenderFns } from "./DataRoot.vue?vue&type=template&id=bd9c32ac&"
import script from "./DataRoot.vue?vue&type=script&lang=js&"
export * from "./DataRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports